import { tr } from '@/lib/i18n-core';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { post } from '@/lib/api';
import { Dialog } from '@/components/ui/layout';
import { Alert, Button, Field, Input, Textarea } from '@/components/ui/primitives';
import { apiMessage } from './LabBenchErrors';

export function LabSendOutDialog({ itemIds, summary, onClose, onSent }: { itemIds: string[]; summary: string; onClose: () => void; onSent: () => void }) {
  const [referenceLab, setReferenceLab] = useState('');
  const [externalRef, setExternalRef] = useState('');
  const [notes, setNotes] = useState('');
  const send = useMutation({
    mutationFn: () =>
      post('/lab/send-out', {
        orderItemIds: itemIds,
        referenceLab: referenceLab.trim(),
        ...(externalRef.trim() ? { externalRef: externalRef.trim() } : {}),
        ...(notes.trim() ? { notes: notes.trim() } : {}),
      }),
    onSuccess: onSent,
  });
  return (
    <Dialog
      open
      onClose={onClose}
      title={`Send ${itemIds.length} test${itemIds.length === 1 ? '' : 's'} to a reference lab`}
      description={tr('lab', 'x_the_result_is_entered_here_when_it_comes_back', { summary: summary })}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {tr('lab', 'cancel')}
          </Button>
          <Button onClick={() => send.mutate()} loading={send.isPending} disabled={referenceLab.trim().length < 2}>
            {tr('lab', 'send_out')}
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        {send.error && <Alert variant="destructive">{apiMessage(send.error)}</Alert>}
        <Field label={tr('lab', 'reference_lab')} required>
          <Input value={referenceLab} maxLength={160} onChange={(e) => setReferenceLab(e.target.value)} />
        </Field>
        <Field label={tr('lab', 'their_reference')} hint={tr('lab', 'optional')}>
          <Input value={externalRef} maxLength={80} onChange={(e) => setExternalRef(e.target.value)} />
        </Field>
        <Field label={tr('lab', 'notes')} hint={tr('lab', 'optional')}>
          <Textarea rows={2} maxLength={600} value={notes} onChange={(e) => setNotes(e.target.value)} />
        </Field>
      </div>
    </Dialog>
  );
}
